import {
  BuildingOffice,
  ChatTwoBubblesOval,
  Lightbulb,
  Target as PlatformChart,
  WaveSignal,
  LayoutGrid,
  MonthlyCalendar,
  NotepadText,
  TrendingContent,
  UserCircleSingle,
  UserSettingBoltNut,
  type IconComponent,
} from '@taskall/react';
import type { Permission } from '@taskall/contracts';

export interface NavItem {
  to: string;
  label: string;
  icon: IconComponent;
  permission: Permission;
}

/** Telas exclusivas da equipe TaskAll (e-mail verificado @taskall.ai). */
export const PLATFORM_NAV_ITEMS: NavItem[] = [
  { to: '/plataforma', label: 'Visão da Plataforma', icon: PlatformChart, permission: 'platform:analytics' },
  { to: '/plataforma/saude', label: 'Saúde dos Sistemas', icon: WaveSignal, permission: 'platform:health' },
];

export const NAV_ITEMS: NavItem[] = [
  { to: '/dashboard', label: 'Dashboard', icon: LayoutGrid, permission: 'dashboard:read' },
  { to: '/turmas', label: 'Turmas', icon: NotepadText, permission: 'class:read' },
  { to: '/alunos', label: 'Alunos', icon: UserCircleSingle, permission: 'student:read' },
  { to: '/escolas', label: 'Escolas', icon: BuildingOffice, permission: 'school:read' },
  { to: '/usuarios', label: 'Usuários', icon: UserSettingBoltNut, permission: 'user:manage' },
  { to: '/solicitacoes', label: 'Solicitações', icon: ChatTwoBubblesOval, permission: 'ouvidoria:read' },
  { to: '/bases-de-conhecimento', label: 'Bases de conhecimento', icon: Lightbulb, permission: 'knowledge:manage' },
  { to: '/agenda', label: 'Agenda', icon: MonthlyCalendar, permission: 'event:read' },
  { to: '/relatorios', label: 'Relatórios', icon: TrendingContent, permission: 'report:read' },
];

const EXTRA_TITLES: Array<[RegExp, string]> = [
  [/^\/turmas\/nova/, 'Nova turma'],
  [/^\/alunos\/novo/, 'Novo aluno'],
  [/^\/escolas\/nova/, 'Cadastrar escola'],
  [/^\/alterar-senha/, 'Alterar senha'],
  [/^\/trocar-senha/, 'Crie sua senha'],
];

/** Página inicial após o login: equipe TaskAll cai na visão da plataforma. */
export function homePath(session: { platformAdmin: boolean } | null | undefined): string {
  return session?.platformAdmin ? '/plataforma' : '/dashboard';
}

/** Título da aba: "<Página> • TaskAll Educação". */
export function pageTitle(pathname: string): string {
  const extra = EXTRA_TITLES.find(([re]) => re.test(pathname))?.[1];
  const item = [...PLATFORM_NAV_ITEMS, ...NAV_ITEMS]
    .filter((i) => pathname === i.to || pathname.startsWith(`${i.to}/`))
    .sort((a, b) => b.to.length - a.to.length)[0];
  const label = extra ?? item?.label;
  const title = label ? `${label} • TaskAll Educação` : 'TaskAll Educação';
  return import.meta.env.VITE_APP_ENV === 'hml' ? `[HML] ${title}` : title;
}
